import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AppDispatch } from '..';

interface LoadState {
  loading: string;
}

const initialState: LoadState = {
  loading: '',
};

const setLoad = createAsyncThunk(
  'load/loading',
  async ({ msm }: { msm: string }, { rejectWithValue }) => {
    try {
      return { loading: msm };
    } catch (error: any) {
      return rejectWithValue(
        error.message || 'Erro ao fazer login. Verifique suas credenciais.'
      );
    }
  }
);

const loadSlice = createSlice({
  name: 'load',
  initialState,
  reducers: {
    loadIsLoading: (state) => {
      state.loading = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setLoad.pending, (state) => {
        state.loading = '';
      })
      .addCase(setLoad.fulfilled, (state, action) => {
        state.loading = action.payload?.loading || '';
      })
      .addCase(setLoad.rejected, (state) => {
        state.loading = '';
      });
  },
});

export const load = {
  show: (dispatch: AppDispatch, msm: string) => {
    dispatch(setLoad({ msm }));
  },
  hide: (dispatch: AppDispatch) => {
    dispatch(setLoad({ msm: '' }));
  },
};

export const { loadIsLoading } = loadSlice.actions;
export default loadSlice.reducer;
